import types from "./types";
import {createError, logError, logSuccess} from "./message";
import api from "../api";

function requestDialogMessages() {
  return {
    type: types.GET_REQUEST_MESSAGES_REQUEST,
    isFetchingMessages: true
  };
}

function requestDialogMessagesCompleted(messageList) {
  return {
    type: types.GET_REQUEST_MESSAGES_COMPLETE,
    isFetchingMessages: false,
    messageList
  };
}

function requestDialogMessagesError(messageListError) {
  return {
    type: types.GET_REQUEST_MESSAGES_ERROR,
    isFetchingMessages: false,
    messageListError
  };
}

export function getRequestMessages(requestId, token) {
  return dispatch => {
    dispatch(requestDialogMessages());
    return api.getRequestMessageList(requestId, token)
      .then(response => {
        if (response.status === 200) {
          dispatch(requestDialogMessagesCompleted(response.data));
          /*console.log(requestId);
          console.log(token);
          console.log(response.data);*/
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestDialogMessagesError(message));
        } else {
          logError(err);
          dispatch(requestDialogMessagesError(createError("Не удалось загрузить сообщения")));
        }
      });
  };
}

export default {
  getRequestMessages
};
